<template>
 <div class="pdfviewer doc-modal">
    <div class="doc-modal__bg js-default-modal-close" @click="close()"></div>
    <div class="doc-modal__content" :class="{'pdfviewer-modal__content' : isPdf}">
      <div class="doc-modal__header">
        <a class="doc-modal__close js-default-modal-close" @click="close()"></a>
      </div>
      <template v-if="isPdf">
        <div class="doc-modal__body" @click="paging()">
          {{currentPage}} / {{pageCount}}
          <pdf
            :src="src"
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </div>
      </template>
      <template v-else>
        <div class="doc-modal__img">
          <img :src="src" alt="" class="js-modal-img" style="max-width: 100%; height: auto; width /***/:auto;">
        </div>
        <p class="doc-modal__caption">{{ fileName }}</p>
      </template>
    </div>
  </div>
</template>

<script>

import pdf from 'vue-pdf'

export default {
  name: 'PdfViewer',
  props: {
    src: String,
    isPdf: {
      default: false,
    },
    fileName: String,
  },
  components: {
    pdf
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      parent: null,
    }
  },
  beforeMount() {
    this.setup()
  },
  mounted() {
    this.show()
  },
  methods: {
    setup() {
      this.parent = document.querySelector('.pdfviewer-parent');
      if (this.parent) return;
      this.parent = document.createElement('div');
      this.parent.className = 'pdfviewer-parent';
      const container = document.body;
      container.appendChild(this.parent);
    },
    show() {
      document.body.insertAdjacentElement('afterbegin', this.$el);
    },
    paging() {
      var nextPage = this.currentPage + 1;
      this.currentPage = (this.pageCount < nextPage) ? 1 : nextPage;
    },
    close() {
      this.$el.remove();
    },
  },
}

</script>

<style scoped>
.pdfviewer-modal__content {
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: 1000px;
  max-height: 740px;
  overflow: auto;
}

.pdfviewer-modal__bg {
  background: rgba(0, 0, 0, 0.8);
  height: 100vh;
  position: absolute;
  width: 100%;
}
</style>
